const getter = {
    menuArr: (state: any)=> state.menu.menuArr,
    permissionArr: (state: any)=> state.permissopm.permissionArr,
    userData: (state: any) => state.user.userData
}
export default getter
